import {getPlaceConfig} from "./place";

const config = getPlaceConfig(2);

export default config
